import React, { useId, useState } from 'react';
import {
  ArrowRightOutlined,
  DownOutlined,
  MessageOutlined,
  UpOutlined,
} from '@ant-design/icons';
import { PublishedRecommendation } from './site-recommendation.service';

interface RecommendationCardProps {
  recommendation: PublishedRecommendation;
  onReadFull?: (recommendation: PublishedRecommendation) => void;
}

const initials = (fullName: string): string =>
  fullName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

const RecommendationCard: React.FC<RecommendationCardProps> = ({
  recommendation,
  onReadFull,
}) => {
  const testimonialId = useId();
  const [expanded, setExpanded] = useState(false);
  const canExpand = recommendation.testimonial.length > 280;

  return (
    <article className="recommendation-card">
      <MessageOutlined
        className="recommendation-card__quote"
        aria-hidden="true"
      />
      <blockquote
        id={testimonialId}
        className={expanded ? 'recommendation-card__text--expanded' : ''}
      >
        {recommendation.testimonial}
      </blockquote>
      {canExpand ? (
        <button
          type="button"
          className="recommendation-card__toggle"
          aria-expanded={onReadFull ? undefined : expanded}
          aria-controls={onReadFull ? undefined : testimonialId}
          aria-haspopup={onReadFull ? 'dialog' : undefined}
          onClick={() =>
            onReadFull
              ? onReadFull(recommendation)
              : setExpanded((current) => !current)
          }
        >
          {expanded && !onReadFull ? 'Show Less' : 'Read Full Recommendation'}
          {onReadFull ? (
            <ArrowRightOutlined aria-hidden />
          ) : expanded ? (
            <UpOutlined aria-hidden />
          ) : (
            <DownOutlined aria-hidden />
          )}
        </button>
      ) : null}
      <footer>
        <span className="recommendation-card__avatar" aria-hidden="true">
          {initials(recommendation.fullName)}
        </span>
        <span className="recommendation-card__person">
          <strong>{recommendation.fullName}</strong>
          <small>{recommendation.currentPosition}</small>
          {recommendation.companyName ? (
            <small className="recommendation-card__company">
              {recommendation.companyName}
            </small>
          ) : null}
        </span>
      </footer>
    </article>
  );
};

export default RecommendationCard;
